import React, { FunctionComponent } from "react";
import { Box, DialogContent, Stack, Toolbar } from "@mui/material";
import { strings } from "../../../localization/LocalizedStrings";
import { ToolbarButton } from "../../toolbar/ToolbarButton";
import styles from "./styles.module.scss";
import { IProduct } from "../../../hooks/products";
import { PurchaseOptionCard } from "../../subscriptions/PurchaseOptionCard";
import { useCreateMercadoPagoPurchasePreference } from "../../../hooks/mercadopago/useCreateMercadoPagoPurchasePreference";
import { StatusCodesHelper } from "../../../models/StatusCodesHelper";
import { useOpenWindow } from "../../../hooks/openWindow";
import { PiperDialog } from "../../PiperDialog";
import { IconType } from "../../../icons/IconType";

export const ProductPurchaseDialog: FunctionComponent<IProductPurchaseDialogProps> = ({
  product,
  isOpen,
  setIsOpen
}) => {
  const { openInNewTab, openInSameTab } = useOpenWindow();
  const { createMercadoPagoPurchasePreference } = useCreateMercadoPagoPurchasePreference();
  const createPreference = async () => {
    const { status, body } = await createMercadoPagoPurchasePreference({ productId: product.id });
    if (StatusCodesHelper.isSuccessful(status)) {
      openInSameTab(body.init_point);
    }
  };
  return (
    <PiperDialog
      fullWidth
      maxWidth={"xs"}
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <Toolbar>
        <h3>{product.name}</h3>
        <Box flexGrow={1} />
        <ToolbarButton
          onClick={() => {
            setIsOpen(false);
          }}
          tooltip={strings.close}
          iconType={IconType.Close}
        />
      </Toolbar>
      <DialogContent>
        <Stack className={styles.textStack} spacing={2}>
          <p className={styles.description}>{product.description}</p>
          <PurchaseOptionCard
            isSubscription={false}
            price={product.finalPriceARS}
            currency={"ARS"}
            imageSrc={"https://piper-public-images.s3.us-east-2.amazonaws.com/MercadoPagoLogo.jpg"}
            buttonText={strings.subscription_pay_with_mercadopago}
            description={strings.purchase_info}
            optionText={strings.pay_option_mercado_pago}
            onClick={() => createPreference()}
          />
          <PurchaseOptionCard
            isSubscription={false}
            price={product.finalPriceUSD}
            currency={"USD"}
            imageSrc={"https://piper-public-images.s3.us-east-2.amazonaws.com/AppleLogo.svg"}
            buttonText={strings.subscription_pay_with_apple}
            description={strings.purchase_info_apple}
            optionText={strings.pay_option_apple}
            onClick={() => openInNewTab(`https://apple.co/3P2tpt7`)}
          />
        </Stack>
      </DialogContent>
    </PiperDialog>
  );
};

export interface IProductPurchaseDialogProps {
  product: IProduct;
  isOpen: boolean;
  setIsOpen: (newValue: boolean) => void;
}
